export const restaurantStatsOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  searchShow: false,
  searchBtn: false,
  refreshBtn: false,
  columnBtn: false,
  menu: false,
  addBtn: false,
  delBtn: false,
  editBtn: false,
  viewBtn: false,
  searchBtn: false,
  column: [
    {
      label: '总经理',
      prop: 'name',
      editDisabled: true,
    },
    {
      label: '比拼岗位',
      prop: 'positionName',
      editDisabled: true,
    },
    {
      label: '参赛人数',
      prop: 'participantsNumber',
      editDisabled: true,
    },
    {
      label: '已公布人数',
      prop: 'hasTotalScoreNumber',
      editDisabled: true,
    },
    {
      label: '已公布平均分',
      prop: 'averageScore',
      editDisabled: true,
    },
  ]
}